/**
 * 여권 영문 이름 입력값 정리 — 영문·공백만 남긴다.
 * 첫 글자 공백이나 연속 공백처럼 받지 말아야 할 입력이면 null (기존 값 유지).
 */
export const sanitizeEnglishName = (value: string): string | null => {
  if (value === ' ') return null;

  const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
  if (/\s{2,}/.test(filteredValue)) return null;

  return filteredValue;
};
